// extracted by mini-css-extract-plugin
export default {"Wrapper":"FormCompleted_Wrapper__A3fEB"};